import {GPSettings} from "./gp-settings-fmg.js";
import {GP} from "../gp.js";
import FMGApp from "./fmg-app.svelte"
import '../../less/fmg/style.less';
import {initTranslator} from "../gp-translations";

document.addEventListener("DOMContentLoaded", async () => {
    await initTranslator();
    new FMGApp({
        target: document.getElementById("maincontainer")
    });

    GP.preinit()
});

window.GP = GP;
